import { apim } from "@/constants/api"

export const formatQuizData = data => {
  for (const key in data) {
    let curItem = data[key]
    if (Array.isArray(curItem)) {
      curItem.forEach(item => formatQuizData(item))
      return
    }
    if (key !== "info") {
      data[key] = curItem?.replace(/<[^>]*>/g, "").replace(/[\r\n]/g, "")
    }
  }
}

export const navQuestion = (dir, curQuestion, setQuestion, totalQuestions) => {
  if (
    (dir === 1 && curQuestion < totalQuestions) ||
    (dir === -1 && curQuestion > 1)
  ) {
    setQuestion(curQuestion + dir)
  }
}

export const generateImageUrl = (url, config, w, h) => {
  if (url) {
    const baseUrl = `${config?.scene7BaseUrl}${config?.dmScene7AccountName}`
    const assetId = url.split("/")?.pop()?.split(".")[0]
    return `${baseUrl}/${assetId}?wid=${w}&hei=${h}&fit=crop&fmt=webp`
  }
  return "#"
}

export const selectAnswer = (q, a, setData, reset = false) => {
  setData(prevState => {
    const newState = structuredClone(prevState)
    const updatedData = {
      ...newState,
      questions: newState.questions.map((question, i) => {
        if (i === q) {
          return {
            ...question,
            answers: question.answers?.map((answer, j) => {
              if (reset) {
                return {
                  ...answer,
                  isSelected: false,
                }
              }
              if (j === a) {
                return {
                  ...answer,
                  isSelected: !answer?.isSelected,
                }
              }
              return answer
            }),
          }
        }
        return question
      }),
    }
    return updatedData
  })
}

export const getFilterQuery = (questions, format = "string") => {
  const queries = {}

  questions.forEach(question => {
    question.answers?.forEach(answer => {
      if (answer.isSelected) {
        let attrs = []
        let values = []

        if (answer.productAttribute.includes(";")) {
          attrs = answer.productAttribute.split(";")
          values = answer.productValue.split(";")
        } else {
          attrs.push(answer.productAttribute)
          values.push(answer.productValue)
        }

        attrs.forEach((attr, i) => {
          if (Array.isArray(queries[attr])) {
            queries[attr].push(values[i])
            queries[attr] = Array.from(new Set(queries[attr]))
          } else {
            queries[attr] = [values[i]]
          }
        })
      }
    })
  })

  let qs = []

  if (format === "string") {
    for (let q in queries) {
      qs.push(`${q}:("${queries[q].join(`","`)}")`)
    }
    if (!qs.length) {
      return ""
    }
    qs = qs.join(" AND ")
  }

  if (format === "array") {
    for (let q in queries) {
      queries[q]?.forEach(item => qs.push({ key: q, value: item }))
    }
  }

  return qs
}

export const fetchProducts = async (query, category) => {
  if (!query) {
    return {}
  }
  const { data } = await apim.get("/search/plp", {
    params: {
      rows: 0,
      start: 0,
      profilename: `profile_kohler-india_${category}`,
      collections: "kohler-india",
      q: "*:*",
      fq: query,
    },
  })
  return data
}

export const isAnswered = (answers = []) => {
  return answers.some(answer => answer.isSelected)
}

export const isFilterValid = (qIndx, facets, setData, reset = false) => {
  setData(prevState => {
    const newState = structuredClone(prevState)
    const updatedData = {
      ...newState,
      questions: newState.questions.map((question, i) => {
        if (i === qIndx) {
          return {
            ...question,
            answers: question.answers?.map(answer => ({
              ...answer,
              notApplicable: reset
                ? false
                : !isFacetAvailable(
                    answer.productAttribute,
                    answer.productValue,
                    facets
                  ),
            })),
          }
        }
        return question
      }),
    }
    return updatedData
  })
}

const isFacetAvailable = (attrName, attrValue, facets) => {
  if (attrName.includes(";")) {
    const attrNames = attrName.split(";")
    const attrValues = attrValue.split(";")

    let isAvailable = false

    attrNames.forEach((item, i) => {
      if (facets[item]?.includes(attrValues[i])) {
        isAvailable = true
      }
    })
    return isAvailable
  } else {
    return facets[attrName]?.includes(attrValue)
  }
}

export const resetQuiz = (setData, setCurQuestion) => {
  setData(prevState => {
    const newState = structuredClone(prevState)
    const updatedData = {
      ...newState,
      questions: newState.questions.map(question => {
        return {
          ...question,
          answers: question.answers?.map(answer => ({
            ...answer,
            notApplicable: false,
            isSelected: false,
          })),
        }
      }),
    }
    return updatedData
  })
  setCurQuestion(1)
}

export const sections = {
  LANDING: "landing",
  QUIZ: "quiz",
  RESULTS: "results",
}

export const plpConfig = {
  share: "false",
  promoLayout: "one-column",
  promoPlacementDesktop: "4",
  promoPlacementMobile: "4",
  defaultImageTag: "kohler-india:imageiso",
  hoverImageTag: "kohler-india:imgroomscene",
  enablePrint: "true",
  enableShare: "true",
  enablePrintPlp: "true",
  enableSharePlp: "true",
  enableShopNowPlp: false,
  bgColor: "bg-gainsboro",
  filterview: "showFilter",
  mpview: "1-col-mpview",
  presentOnDesktop: "false",
  presentOnMobile: "false",
  isServiceParts: "",
  presetConfigs:
    '{"Desktop":"PLPDesktop596","MobilePortrait1":"PLPMobile354","MobilePortrait2":"PLPMobile174","MobileLandscape1":"$PLPMobile1up$","MobileLandscape2":"PLPMobile426","PotraitCategory":"GBH_DataDrivenVerticalTemplate"}',
  swatchUrl: "https://kohler.scene7.com/is/image/PAWEB/",
}
